export const TRANSLATIONS_EN = {
  academie: "academy",
  usage: "uses",
  service: "network",
  planification: "planning",
  rapport: "Reports",
};
